// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Spend = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.21 2.363 1.17 5.857a.56.56 0 0 0-.398.689l2.33 8.693c.08.3.388.478.688.398l13.04-3.494c.3-.08.478-.389.398-.689l-2.33-8.693a.563.563 0 0 0-.688-.398M12.445 10.989l2.173-.583M9.185 11.862l1.086-.29M1.354 8.72l14.127-3.786"
    />
  </svg>
);
const ForwardRef = forwardRef(Spend);
export default ForwardRef;
